import { useNavigate } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { Minus, Plus, X } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { inr } from "../lib/api";

export default function CartDrawer({ open, onOpenChange }) {
  const { cart, updateQty, removeFromCart, cartTotal } = useStore();
  const navigate = useNavigate();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-md bg-ivory border-line flex flex-col p-0" data-testid="cart-drawer">
        <SheetHeader className="px-6 pt-6 pb-4 border-b border-line">
          <SheetTitle className="font-serif text-2xl text-left tracking-tight">
            Your Bag ({cart.length})
          </SheetTitle>
        </SheetHeader>

        {cart.length === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-4 px-6 text-center">
            <p className="font-serif text-3xl">Your bag is empty</p>
            <p className="text-sm text-ink-soft">Discover pieces worth keeping forever.</p>
            <button onClick={() => { onOpenChange(false); navigate("/shop"); }} className="btn-outline mt-2 px-8 py-3 overline">
              Explore the atelier
            </button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto px-6 py-4 space-y-5">
              {cart.map((item) => (
                <div key={item.key} className="flex gap-4" data-testid={`cart-item-${item.slug}`}>
                  <img src={item.image} alt={item.name} className="h-28 w-20 object-cover bg-[#efece6]" />
                  <div className="flex flex-1 flex-col">
                    <div className="flex justify-between gap-2">
                      <h4 className="font-serif text-lg leading-tight">{item.name}</h4>
                      <button onClick={() => removeFromCart(item.key)} data-testid={`cart-remove-${item.slug}`}>
                        <X size={16} className="text-ink-soft hover:text-ink" />
                      </button>
                    </div>
                    <p className="overline text-ink-soft mt-1">Size {item.size}</p>
                    <div className="mt-auto flex items-center justify-between">
                      <div className="flex items-center border border-line">
                        <button className="px-2 py-1.5" onClick={() => updateQty(item.key, item.quantity - 1)}><Minus size={12} /></button>
                        <span className="w-8 text-center text-sm">{item.quantity}</span>
                        <button className="px-2 py-1.5" onClick={() => updateQty(item.key, item.quantity + 1)}><Plus size={12} /></button>
                      </div>
                      <span className="text-sm">{inr(item.price * item.quantity)}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="border-t border-line px-6 py-5 space-y-4">
              <div className="flex justify-between text-sm">
                <span className="text-ink-soft">Subtotal</span>
                <span>{inr(cartTotal)}</span>
              </div>
              <p className="text-xs text-ink-soft">Taxes & insured shipping calculated at checkout.</p>
              <button
                onClick={() => { onOpenChange(false); navigate("/checkout"); }}
                className="btn-ink w-full py-4 overline"
                data-testid="cart-checkout-btn"
              >
                Proceed to Checkout
              </button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
